export default __webpack_public_path__ + "static/teammate1-6975b4020068895541c351ac5f515909.png";